const initialState = {
  plan: null,
  catalog: null,
  recommendedProducts: [],
  loaded: false,
  error: null,
  generating: false,
  generatingBrandAngles: false,
  brandAnglesError: null,
  saving: false,
}

const launchAdsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'CHANGE_LAUNCH_ADS_PLAN':
      return {
        ...state,
        plan: action.payload.plan,
        catalog: action.payload.catalog ?? state.catalog,
        recommendedProducts:
          action.payload.recommendedProducts ?? state.recommendedProducts,
        error: null,
      }
    case 'CHANGE_LAUNCH_ADS_LOADED':
      return { ...state, loaded: action.payload }
    case 'CHANGE_LAUNCH_ADS_ERROR':
      return { ...state, error: action.payload }
    case 'CHANGE_LAUNCH_ADS_GENERATING':
      return { ...state, generating: action.payload }
    case 'CHANGE_LAUNCH_ADS_GENERATING_BRAND_ANGLES':
      return { ...state, generatingBrandAngles: action.payload }
    case 'CHANGE_LAUNCH_ADS_BRAND_ANGLES_ERROR':
      return { ...state, brandAnglesError: action.payload }
    case 'CHANGE_LAUNCH_ADS_SAVING':
      return { ...state, saving: action.payload }
    default:
      return { ...state }
  }
}

export default launchAdsReducer
